import { render } from "./Footer.vue?vue&type=template&id=12f349eb&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=12f349eb&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f349eb"]])

export default __exports__